<!--
* UIID: UI-CAAS-COM-112
* UI Name: SMTP
* Modify Date: 2020/06/15
-->
<template>
  <div>
    <v-form ref="form">
      <!-- 2 Row 54px-->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Server address</v-label>
          <v-text-field
            v-model="formData.host"
            :rules="[validationUtils.required, validationUtils.max(50)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-row>
            <v-col cols="12" md="8" class="py-0 pr-1">
              <v-label>Security</v-label>
              <v-select
                v-model="formData.security"
                :items="securities"
                solo
                :menu-props="{ offsetY: true }"
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Port</v-label>
              <v-text-field
                v-model="formData.port"
                type="number"
                :rules="[validationUtils.required, validationUtils.max(5)]"
                solo
                :disabled="!$auth.manage"
                :readonly="isHistory"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--3 Row 40px-->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>User ID</v-label>
          <v-text-field
            v-model="formData.userid"
            :rules="[validationUtils.required, validationUtils.max(200)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
            autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Password</v-label>
          <v-text-field
            v-model="formData.password"
            :append-icon="formData.showpassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="formData.showpassword ? 'text' : 'password'"
            @click:append="formData.showpassword = !formData.showpassword"
            :rules="[validationUtils.required, validationUtils.max(50)]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
            autocomplete="off"
            @focus="handlePasswordType"
            @blur="handlePasswordType"
          ></v-text-field>
        </v-col>
      </v-row>
      <!--4 Row -->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label>{{ $t('lbl.communications.senderEmail') }}</v-label>
          <v-text-field
            v-model="formData.senderEmail"
            :rules="
              formData.senderEmail
                ? [validationUtils.multiEmailRules(10), validationUtils.max(100)]
                : []
            "
            solo
            :disabled="!$auth.manage"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label
            ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>Recepient Email Address</v-label
          >
          <v-text-field
            v-model="formData.email"
            :rules="[
              validationUtils.required,
              validationUtils.multiEmailRules(10),
              validationUtils.max(500),
            ]"
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="px-2 py-0">
          <v-label>Email Subject</v-label>
          <v-text-field
            v-model="formData.emailSubject"
            :rules="
              formData.emailSubject && formData.emailSubject.length > 300
                ? ['Max 300 characters']
                : []
            "
            solo
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- /**
         * 2022.12.13 213979 SPKA-597 Add "Body" in Add/Modify Communication popup for SMTP
         */ -->
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label>Body</v-label>
        </v-col>
        <v-col cols="12" md="6" class="px-2 py-0 d-flex justify-end align-center">
          <v-label>Attach (File)</v-label>
          <v-checkbox
            v-model="formData.attach"
            color="#497DDE"
            dense
            hide-details
            class="mt-0 ml-2 pt-0"
            true-value="Y"
            false-value="N"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" md="12" class="py-0 px-2">
          <v-textarea
            v-model="formData.body"
            solo
            height="60"
            :rules="formData.body && formData.body.length > 300 ? ['Max 300 characters'] : []"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="px-2 py-0">
          <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
          <v-text-field
            v-model="formData.maxRetry"
            type="number"
            solo
            :disabled="!$auth.manage"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    item: {
      default: Object,
    },
    nodeId: {
      type: String,
    },
    isHistory: {
      default: false,
    },
  },

  data: () => {
    return {
      securities: [
        { text: 'NONE', value: 'NONE' },
        { text: 'SSL', value: 'SSL' },
        { text: 'TLS', value: 'TLS' },
      ],
      inouts: [
        { value: 'I', text: 'INBOUND' },
        { value: 'O', text: 'OUTBOUND' },
      ],
      formData: {},
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
    };
  },

  created() {
    this.resetFormData();
  },

  watch: {
    item() {
      this.resetFormData();
      // this.setFocus();
    },
  },

  methods: {
    handlePasswordType(event) {
      const { srcElement, type } = event;
      const { value } = srcElement;
      if (type === 'focus' && !value) {
        this.formData.showpassword = false;
      }
      if (type === 'blur' && !value) {
        this.formData.showpassword = true;
      }
    },
    checkDataChange() {
      let editedData = getEditData(this.formData, this.loadFormData);
      this.$emit('check-data-change', editedData);
    },
    async save(item) {
      let validResult = this.$refs.form.validate();
      if (!validResult) return -1;
      this.formData.id = item.id;
      this.formData.type = item.type;
      this.formData.name = item.name;
      this.formData.protocol = item.type;
      let editedData = getEditData(this.formData, this.loadFormData);
      editedData.id = this.formData.id;
      editedData.name = this.formData.name;
      editedData.protocol = this.formData.type;
      if (this.formData.id) {
        await this.$store
          .dispatch('editCommFromProcSetup', this.formData)
          .then(() => {
            this.sendActivate(this.formData.id, 'COM', editedData);
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      } else {
        await this.$store
          .dispatch('insertCommFromProcSetup', this.formData)
          .then(() => {
            this.formData.id = this.$store.getters.communicationId;
            let formEmit = {
              comId: this.formData.id,
              nodeId: this.nodeId,
              type: 'COM',
            };
            EventBus.$emit('refresh-list-component', formEmit);
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },

    getInitData() {
      return {
        name: '',
        partner: '',
        direction: '',
        host: '',
        security: '',
        port: '',
        userid: '',
        password: '',
        showpassword: true,
        email: '',
        type: 'SMTP',
        body: 'Please check attached file',
        attach: false,
      };
    },
    // hasEditForm() {
    //   const defaultForm = this.getInitData();
    //   for (const prop in defaultForm) {
    //     if (prop != 'showpassword' && prop != 'type') {
    //       if (this.formData[prop].trim() != '') {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // },
    resetFormData() {
      this.formData = Object.assign({}, this.getInitData(), this.item);

      if (this.formData.password) this.formData.showpassword = false;
      this.loadFormData = Object.assign({}, this.getInitData(), this.item);
      if (this.loadFormData.password) this.loadFormData.showpassword = false;
      if (this.formData.email == null) {
        this.formData.email = '';
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.name.focus();
      }, 300);
    },
  },
};
</script>

<style></style>
